<template>
  <hr
    class="my-6 border-left-none border-right-none border-top-none border-bottom-1 border-coldgray-150"
  />
</template>
<script setup lang="ts"></script>
